import { BodyResearchTypeOperation } from 'practice/view-models/research-type-operation';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<BodyResearchTypeOperation, keyof BodyResearchTypeOperation>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'descriptionBrief',
    label: 'Descrizione breve',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'practice',
    label: 'Pratica',
  },
  {
    id: 'typeDocument',
    label: 'Tipo documento',
  },
  {
    id: 'printDoc',
    label: 'Stampa doc (Si/No)',
  },
  {
    id: 'inUse',
    label: 'In uso',
  },
  {
    id: 'action',
    label: '',
  },
];
